<div>
    <mat-icon
        (click)="toggleLockedStatus()"
        class="unlocked"
        *ngIf="!fieldLockService.isLocked(fieldName)"
        [matTooltip]="unlockedToolTip"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
    >sync</mat-icon>
    <mat-icon
        (click)="toggleLockedStatus()"
        class="locked"
        *ngIf="fieldLockService.isLocked(fieldName)"
        [matTooltip]="lockedToolTip"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
    >sync_lock</mat-icon>
</div>